// extracted by mini-css-extract-plugin
export default {"txhd":"TopSection_txhd__aS+KY","wrtnt":"TopSection_wrtnt__ffLns"};